import { BatchesService } from '@festina/unitlink-general-types/unitlink/services/BatchesService'
import { useFestinaMutation } from '@festina-life/authentication'

const method = BatchesService.batchesServicePostCreate
type MethodParam = NonNullable<Parameters<typeof method>[0]['requestBody']>

export const useSubmitUnitLinkBatch = () =>
  useFestinaMutation({
    component: 'unitLink',
    roles: BatchesService.batchesServicePostCreate_roles,
    isScenario: false,
    mutateFunction: async (arg: MethodParam) => {
      await method({ requestBody: arg })
    },
  })
